import ChartAPI from "../../apps/common/chart-api";

export default {
    namespaced: true,
    state: {
        final: [],
        final_by_day: [],
        start_date: null,
        end_date: null,
        keyword_types: [],
        loading: false,
    },
    actions: {
        async fetchAdQuality({ commit, rootGetters }) {
            const projectId = rootGetters["currentProjectId"];
            if (!projectId) return;

            commit("setLoading", true);
            commit("setData", { final: [], final_by_day: [], start_date: null, end_date: null, keyword_types: [] });

            const params = rootGetters["ad_quality/queryParams"];
            const studObj = new ChartAPI();

            try {
                const data = await studObj.sendRequest(
                    "getAdQuality",
                    projectId,
                    `?${params}`
                );
                if (data && data.final !== undefined) {
                    commit("setData", {
                        final: data.final || [],
                        final_by_day: data.final_by_day || [],
                        start_date: data.start_date,
                        end_date: data.end_date,
                        keyword_types: data.keyword_types || [],
                    });
                }
            } finally {
                commit("setLoading", false);
            }
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setData(state, { final, final_by_day, start_date, end_date, keyword_types }) {
            state.final = final || [];
            state.final_by_day = final_by_day || [];
            state.start_date = start_date;
            state.end_date = end_date;
            state.keyword_types = keyword_types || [];
        },
    },
    getters: {
        final: (state) => state.final,
        final_by_day: (state) => state.final_by_day,
        start_date: (state) => state.start_date,
        end_date: (state) => state.end_date,
        keyword_types: (state) => state.keyword_types || [],
        loading: (state) => state.loading,
        queryParams(state, getters, rootState, rootGetters) {
            let params = rootGetters["filters/dateRangeParam"];
            params += rootGetters["filters/deviceTypesParam"] || "";
            params += rootGetters["filters/searchEngineParam"] || "";
            params += rootGetters["filters/keywordsTypesParam"] || "";
            params += rootGetters["filters/geoLocationsParam"] || "";
            params += rootGetters["filters/keywordsParam"] || "";
            if (rootGetters["filters/comparingState"]) {
                params += "&comparing=true&" + rootGetters["filters/dynamicDashboardParams"];
            }
            return params;
        },
        exportUrls(state, getters, rootState, rootGetters) {
            const params = getters.queryParams;
            return [`?${params}`];
        },
    },
};
